import IssuedCertificates from './components/List/IssuedCertiticatesTab/IssuedCertificates';
import ReadyForCertificatesTab from './components/List/ReadyForCertificateTab/ReadyForCertificatesTab';
import { ListLayout } from '../../../components/layout/layout/ListLayout';
import { Tabs } from 'antd';
import { useCustomSearchParams } from 'hooks/useSearchParams';

export const CertificateList = () => {
  const { currentSearchParams: currentTab, setSearchParams } =
    useCustomSearchParams({ searchParams: 'tab' });

  const itemsTabs = [
    {
      key: 'ready_for_certificate',
      label: 'Certificados para emitir',
      children: <ReadyForCertificatesTab />
    },
    {
      key: 'issued',
      label: 'Certificados emitidos',
      children: <IssuedCertificates />
    }
  ];

  return (
    <ListLayout title="Certificados de Cursos Regulares" canCreate={false}>
      <Tabs
        defaultActiveKey={currentTab || 'ready_for_certificate'}
        onChange={activeKey => setSearchParams(activeKey)}
        className="custom-tabs"
        items={itemsTabs}
      />
    </ListLayout>
  );
};
